const orgs = [
    {
        key: 1,
        name: "Mission Smile",
        type: "NGO",
        contact: "033 2345 939",
        address: "Dpsc Plot No X-1, 2 ,& 3 Block Ep, Sector 5, Salt Lake, Kolkata 700091 West Bengal",
        lat: 22.569510,
        lon: 88.453060
    },
    {
        key: 2,
        name: "Rural Health Care Foundation",
        type: "NGO",
        contact: "033 2345 939",
        address: "63, Chowringhee Road, 33, Alexander Court Kolkata-700020 West Bengal",
        lat: 22.539930,
        lon: 88.346950
    },
    {
        key: 3,
        name: "Nabadiganta",
        type: "OldAgeHome",
        contact: "033 2345 939",
        address: "29 Banerjeepara Road, Sarsuna, Kolkata-700061",
        lat: 22.478790,
        lon: 88.288490
    },
    {
        key: 4,
        name: "Janasiksha Prochar Kendra",
        type: "OldAgeHome",
        contact: "033 2345 939",
        address: "57-B, College Street, Kolkata-700073",
        lat: 22.579590,
        lon: 88.360710
    },
    {
        key: 5,
        name: "Ramkrishna Satyanabda Ashram",
        type: "OldAgeHome",
        contact: "033 2345 939",
        address: "46/2 Desh Bandhu Road, Kolkata-700032",
        lat: 22.469590,
        lon: 88.360710
    },
    {
        key: 6,
        name: "Elderly Helpers",
        type: "NGO",
        contact: "033 2345 939",
        address: "North Dumdum, Kolkata-700032",
        lat: 22.635565,
        lon: 88.383808
    },
    {
        key: 7,
        name: "Life Care",
        type: "BloodBank",
        contact: "033 2345 939",
        address: "North Dumdum, Kolkata-700032",
        lat: 22.635565,
        lon: 88.383808
    },
    {
        key: 8,
        name: "People's Blood Bank",
        type: "BloodBank",
        contact: "033 2345 939",
        address: "North Dumdum, Kolkata-700032",
        lat: 22.478790,
        lon: 88.288490
    },
    {
        key: 9,
        name: "Lions Blood Bank",
        type: "BloodBank",
        contact: "033 2345 939",
        address: "North Dumdum, Kolkata-700032",
        lat: 22.579590,
        lon: 88.60710
    },
    {
        key: 10,
        name: "Park Blue Print",
        type: "MedicineShop",
        contact: "098303 08087",
        address: "Park Street Kolkata-700016",
        lat: 22.560100,
        lon: 88.350730
    },
    {
        key: 11,
        name: "Dhanwantary Pharmacy",
        type: "MedicineShop",
        contact: "098305 84845",
        address: " Bhowanipore Kolkata-700020",
        lat: 22.538210,
        lon: 88.344850
    },
    {
        key: 12,
        name: "Retail Medicine Shop",
        type: "MedicineShop",
        contact: "083359 15772",
        address: "Kakurgachi Kolkata-700013",
        lat: 22.580150,
        lon: 88.391080
    }

]

export default orgs;